"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTimezones = void 0;
const en_GB_1 = __importDefault(require("./en-GB"));
const en_BE_1 = __importDefault(require("./en-BE"));
const en_NL_1 = __importDefault(require("./en-NL"));
const fr_FR_1 = __importDefault(require("./fr-FR"));
const en_AU_1 = __importDefault(require("./en-AU"));
const en_IE_1 = __importDefault(require("./en-IE"));
const nl_NL_1 = __importDefault(require("./nl-NL"));
const UNITED_KINGDOM = 'en-GB';
const BELGIUM = 'en-BE';
const FRANCE = 'fr-FR';
const AUSTRALIA = 'en-AU';
const IRELAND = 'en-IE';
const NETHERLANDS_ENGLISH = 'en-NL';
const NETHERLANDS_DUTCH = 'nl-NL';
exports.defaultTimezones = {
    [UNITED_KINGDOM]: 'Europe/London',
    [BELGIUM]: 'Europe/Brussels',
    [FRANCE]: 'Europe/Paris',
    [AUSTRALIA]: 'Australia/Sydney',
    [IRELAND]: 'Europe/Dublin',
    [NETHERLANDS_ENGLISH]: 'Europe/Amsterdam',
    [NETHERLANDS_DUTCH]: 'Europe/Amsterdam',
};
exports.default = {
    [UNITED_KINGDOM]: en_GB_1.default,
    [BELGIUM]: en_BE_1.default,
    [FRANCE]: fr_FR_1.default,
    [AUSTRALIA]: en_AU_1.default,
    [IRELAND]: en_IE_1.default,
    [NETHERLANDS_ENGLISH]: en_NL_1.default,
    [NETHERLANDS_DUTCH]: nl_NL_1.default,
};
//# sourceMappingURL=markets.js.map